export default __webpack_public_path__ + "static/media/OUR PROJECTS.bddbd7b1.jpg";